/**
 * Where the chat's links go in the app that hosts it. The web app has an Activity page for plans; the apps panel
 * (apps/crm) has none, so it gives no plan path and the card shows no "Open in Activity" button.
 */
import { createContext, useContext, type ReactNode } from 'react';

export interface ChatLinks {
  /** The page where a plan can be decided and followed, or null when this app has none. */
  planPath: ((planId: string) => string) | null;
}

const WEB_LINKS: ChatLinks = { planPath: (planId) => `/activity?plan=${encodeURIComponent(planId)}` };

const ChatLinksContext = createContext<ChatLinks>(WEB_LINKS);

export function ChatLinksProvider({ links, children }: { links: ChatLinks; children: ReactNode }) {
  return <ChatLinksContext.Provider value={links}>{children}</ChatLinksContext.Provider>;
}

export function useChatLinks(): ChatLinks {
  return useContext(ChatLinksContext);
}
